import { formatHistoryDate } from "../lib/dates"
import { byNumber, byString } from "../lib/sorters"
import { ISbSdHistoryRecord } from "../types/history.types"

const formatMoney = (value: unknown) =>
  value == null || value === "" ? "—" : `$${Number(value).toFixed(2)}`

const formatStatus = (row: ISbSdHistoryRecord) =>
  [row.isRun, row.failReason].filter(Boolean).join(": ") || "—"

const SB_SD_HISTORY_COLUMNS = [
  {
    title: "Campaign Name",
    render: (row: ISbSdHistoryRecord) => row.campaignName ?? "-",
    sorter: byString("campaignName"),
  },
  {
    title: "Target Name",
    render: (row: ISbSdHistoryRecord) => row.targetName || row.targetId || "—",
    sorter: byString("targetName"),
  },
  {
    title: "Bid Before",
    render: (row: ISbSdHistoryRecord) => formatMoney(row.oldBid),
    sorter: byNumber("oldBid"),
  },
  {
    title: "Bid After",
    render: (row: ISbSdHistoryRecord) => formatMoney(row.bid),
    sorter: byNumber("bid"),
  },
  {
    title: "Placements Before",
    render: (row: ISbSdHistoryRecord) => row.placementsBefore ?? "—",
    sorter: byString("placementsBefore"),
  },
  {
    title: "Placements After",
    render: (row: ISbSdHistoryRecord) => row.placementsAfter ?? "—",
    sorter: byString("placementsAfter"),
  },
  {
    title: "Status",
    render: formatStatus,
    sorter: byString("isRun"),
  },
  {
    title: "Updated At",
    render: (row: ISbSdHistoryRecord) => formatHistoryDate(row.updatedAt),
    sorter: byString("updatedAt"),
  },
]

const useSbSdHistoryColumns = () => SB_SD_HISTORY_COLUMNS

export default useSbSdHistoryColumns
